import type { AnyFormData, FieldAdapterProps, FieldPath, FieldValue } from "../types";
import { useFieldRefsContext } from "./FieldRefsContext";
import { useFormContext } from "./contexts";

export const FieldAdapter = <
    TFormData extends AnyFormData,
    TName extends FieldPath<TFormData>,
    TValue = FieldValue<TFormData, TName>,
>({
    name,
    listeners,
    children,
}: FieldAdapterProps<TFormData, TName, TValue>) => {
    const form = useFormContext();
    const { registerFieldRef } = useFieldRefsContext();

    return (
        <form.Field
            // @ts-ignore FIXME
            name={name}
            listeners={{
                onChange: ({ value }) => {
                    listeners?.onChange?.(value as any);
                },
            }}
            children={(field) =>
                children({
                    value: field.state.value as any,
                    onChange: (value) => {
                        field.handleChange(value as any);
                    },
                    ref: (instance) => registerFieldRef(name, instance),
                })
            }
        />
    );
};
